import { render } from "./MypageLayout.vue?vue&type=template&id=4fce68ce&scoped=true&ts=true"
import script from "./MypageLayout.vue?vue&type=script&lang=ts"
export * from "./MypageLayout.vue?vue&type=script&lang=ts"

import "./MypageLayout.vue?vue&type=style&index=0&id=4fce68ce&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fce68ce"]])

export default __exports__